<template>
    <div>
        <v-simple-table dense>
            <tbody>
                <tr>
                    <th>{{ $t('code') }}</th>
                    <td>{{ customer.code }}</td>
                </tr>
                <tr>
                    <th>{{ $t('name') }}</th>
                    <td>
                        {{ customer.name }}
                        <span>
                            <v-btn
                                icon
                                x-small
                                @click="openCustomerDisplayDialog">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('phone') }}</th>
                    <td>{{ customer.phone }}</td>
                </tr>
                <tr>
                    <th>{{ $t('address') }}</th>
                    <td>{{ customer.address }}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <customer-display-dialog
            ref="customerDisplayDialog">
        </customer-display-dialog>
    </div>
</template>

<script>
import { getCustomer } from '../../services/sales/customer';
import CustomerDisplayDialog from '../Sales/CustomerDisplayDialog';

export default {
    name: "DocumentCustomerPreview",
    components: { CustomerDisplayDialog },
    props: {
        id: { type: Number, required: true },
        loading: Boolean
    },
    data() {
        return {
            customer: {}
        }
    },
    computed: {
        isLoading: {
            get() {
                return this.loading;
            },
            set(val) {
                this.$emit("update:loading", val)
            }
        }
    },
    methods: {
        openCustomerDisplayDialog() {
            this.$refs.customerDisplayDialog.open({ id: this.customer.id });
        },
        fetchCustomerData() {
            this.isLoading = true;
            getCustomer(this.id).then(response => {
                this.customer = response.data;
                this.isLoading = false;
            });
        }
    },
    created() {
        this.fetchCustomerData();
    }
}
</script>
